/* Beauty Club — theme.js
   Animazioni (GSAP + ScrollTrigger + Lenis), carrello AJAX, varianti prodotto, filtri collezione. */
(() => {
  const T = window.theme;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const html = document.documentElement;
  const design = window.Shopify && Shopify.designMode;
  const isDesk = () => matchMedia('(min-width:901px)').matches;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const anim = html.classList.contains('js-anim') && window.gsap && window.ScrollTrigger && !reduced;
  if (!anim) html.classList.remove('js-anim');
  if (anim) gsap.registerPlugin(ScrollTrigger);
  window.__animReady = true;

  /* ---------- money ---------- */
  function money(cents) {
    const fmt = T.moneyFormat || 'CHF {{amount}}';
    const v = (cents || 0) / 100;
    const grp = (n, d, t, s) => { const [i, f] = n.toFixed(d).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (f ? s + f : ''); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: grp(v, 2, ',', '.'),
      amount_no_decimals: grp(v, 0, ',', '.'),
      amount_with_comma_separator: grp(v, 2, '.', ','),
      amount_no_decimals_with_comma_separator: grp(v, 0, '.', ','),
      amount_with_apostrophe_separator: grp(v, 2, "'", '.'),
      amount_with_space_separator: grp(v, 2, ' ', ','),
    })[k] || grp(v, 2, ',', '.')).replace(/<[^>]+>/g, '');
  }
  const esc = s => String(s ?? '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* ---------- smooth scroll ---------- */
  let lenis = null;
  if (anim && T.smoothScroll && window.Lenis) {
    lenis = new Lenis({ lerp: .09, prevent: node => !!node.closest?.('[data-lenis-prevent], .drawer, .filters-panel, .mnav, .up-track') });
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(t => lenis.raf(t * 1000));
    gsap.ticker.lagSmoothing(0);
  }
  const lock = on => { if (lenis) on ? lenis.stop() : lenis.start(); document.body.style.overflow = on ? 'hidden' : ''; };
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;
    const id = a.getAttribute('href');
    if (id.length < 2 || !$(id)) return;
    e.preventDefault();
    lenis ? lenis.scrollTo(id, { offset: -80, duration: 1.6 }) : $(id).scrollIntoView({ behavior: 'smooth' });
  });

  /* ---------- header ---------- */
  const header = $('.site-header');
  const setHdr = () => { if (header) document.body.style.setProperty('--hdr-h', header.offsetHeight + 'px'); };
  const onScroll = y => header && header.classList.toggle('solid', y > 80);
  lenis ? lenis.on('scroll', e => onScroll(e.scroll)) : addEventListener('scroll', () => onScroll(scrollY), { passive: true });
  addEventListener('resize', setHdr); setHdr(); onScroll(scrollY);

  const mnav = $('#mnav');
  document.addEventListener('click', e => {
    if (e.target.closest('[data-open-menu]')) { mnav?.classList.add('on'); lock(true); }
    if (e.target.closest('[data-close-menu]')) { mnav?.classList.remove('on'); lock(false); }
  });
  $$('.loc select').forEach(s => s.addEventListener('change', () => s.form.submit()));

  /* ---------- cursor ---------- */
  const cur = $('#cursor');
  if (cur && T.customCursor && matchMedia('(hover:hover)').matches && window.gsap) {
    let cx = -100, cy = -100, kx = -100, ky = -100;
    addEventListener('mousemove', e => { cx = e.clientX; cy = e.clientY; cur.classList.add('on'); });
    document.addEventListener('mouseleave', () => cur.classList.remove('on'));
    gsap.ticker.add(() => { kx += (cx - kx) * .2; ky += (cy - ky) * .2; gsap.set(cur, { x: kx, y: ky }); });
    document.addEventListener('mouseover', e => {
      const el = e.target.closest('[data-cursor]');
      if (el && !e.target.closest('button,.btn')) { cur.classList.add('big'); cur.firstElementChild.textContent = el.dataset.cursor; }
      else cur.classList.remove('big');
    });
  } else cur?.remove();

  /* ---------- toast ---------- */
  let tt;
  function toast(h) { const t = $('#toast'); if (!t) return; t.innerHTML = h; t.classList.add('on'); clearTimeout(tt); tt = setTimeout(() => t.classList.remove('on'), 2600); }

  /* =========================================================
     CART
     ========================================================= */
  const drawer = $('#drawer'), veil = $('#veil');
  const SEC = 'cart-drawer';
  const cfg = () => { try { return JSON.parse($('[data-drawer-cfg]')?.textContent || '{}'); } catch (e) { return {}; } };
  let lastFocus = null;
  const openCart = on => {
    if (!drawer) return;
    drawer.classList.toggle('on', on); veil.classList.toggle('on', on); lock(on);
    if (on) { lastFocus = document.activeElement; setTimeout(() => $('[data-close-cart]', drawer)?.focus(), 50); loadUpsell(); }
    else lastFocus?.focus?.();
  };
  // sostituisce il contenuto del drawer con l'HTML della sezione renderizzata da Shopify
  function paint(sections) {
    const html = sections && sections[SEC]; if (!html || !drawer) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('.shopify-section') || doc.body;
    const scroll = $('[data-cart-items]', drawer)?.scrollTop || 0;
    const wrap = $('#shopify-section-' + SEC, drawer) || drawer;
    wrap.innerHTML = fresh.innerHTML;
    const items = $('[data-cart-items]', drawer); if (items) items.scrollTop = scroll;
    const n = $('[data-cart-count]', drawer)?.textContent || '0';
    $$('[data-cart-count]').forEach(el => el.textContent = n);
    upsellLoaded = false; if (drawer.classList.contains('on')) loadUpsell();
  }
  const post = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ...body, sections: SEC, sections_url: location.pathname }) });
  async function refresh() { const r = await fetch(`${location.pathname}?sections=${SEC}`); if (r.ok) paint(await r.json()); }
  async function busy(fn) { drawer?.classList.add('is-busy'); try { return await fn(); } finally { drawer?.classList.remove('is-busy'); } }

  let upsellLoaded = false;
  async function loadUpsell() {
    const box = $('[data-upsell]', drawer); if (!box || upsellLoaded) return;
    upsellLoaded = true;
    const r = await fetch(box.dataset.upsell); if (!r.ok) return;
    const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
    const cards = $$('[data-upsell-cards] .up', doc);
    if (!cards.length) return;
    const track = $('.up-track', box); track.innerHTML = ''; cards.forEach(c => track.appendChild(document.importNode(c, true)));
    box.hidden = false;
  }

  drawer?.addEventListener('click', async e => {
    const q = e.target.closest('[data-key]');
    if (q) { const r = await busy(() => post(T.routes.cartChange + '.js', { id: q.dataset.key, quantity: Math.max(0, +q.dataset.q) })); const d = await r.json(); if (!r.ok) toast(esc(d.description || d.message || T.strings.error)); else paint(d.sections); return; }
    const rc = e.target.closest('[data-remove-code]');
    if (rc) { const codes = $$('[data-remove-code]', drawer).map(b => b.dataset.removeCode).filter(c => c !== rc.dataset.removeCode); const r = await busy(() => post('/cart/update.js', { discount: codes.join(',') })); if (r.ok) paint((await r.json()).sections); }
  });
  drawer?.addEventListener('submit', async e => {
    const f = e.target.closest('[data-discount]'); if (!f) return;
    e.preventDefault();
    const code = f.code.value.trim(); if (!code) return;
    const codes = $$('[data-remove-code]', drawer).map(b => b.dataset.removeCode).concat(code);
    const r = await busy(() => post('/cart/update.js', { discount: [...new Set(codes)].join(',') }));
    const d = await r.json(); if (!r.ok) return;
    paint(d.sections);
    const ok = (d.discount_codes || []).find(x => x.code.toLowerCase() === code.toLowerCase());
    const msg = $('[data-discount-msg]', drawer);
    if (msg) msg.textContent = ok && ok.applicable ? '✦ ' + T.strings.discountOk : T.strings.discountInvalid;
  });
  let noteT;
  drawer?.addEventListener('input', e => {
    const n = e.target.closest('[data-cart-note]'); if (!n) return;
    clearTimeout(noteT); noteT = setTimeout(() => fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: n.value }) }), 500);
  });
  drawer?.addEventListener('change', async e => {
    const g = e.target.closest('[data-gift]'); if (!g) return;
    const r = await busy(() => post('/cart/update.js', { attributes: { [g.dataset.gift]: g.checked ? '✓' : '' } }));
    if (r.ok) paint((await r.json()).sections);
  });
  // focus trap
  drawer?.addEventListener('keydown', e => {
    if (e.key !== 'Tab' || !drawer.classList.contains('on')) return;
    const f = $$('a[href],button:not([disabled]),input,textarea,summary', drawer).filter(x => x.offsetParent);
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });
  document.addEventListener('click', e => {
    if (e.target.closest('[data-open-cart]') && drawer) { e.preventDefault(); openCart(true); refresh(); }
    if (e.target.closest('[data-close-cart]')) openCart(false);
  });

  // tutti i form "aggiungi" (card, rituale, pagina prodotto, upsell) passano da qui
  document.addEventListener('submit', async e => {
    const f = e.target.closest('form[data-add]');
    if (!f) return;
    e.preventDefault();
    const btn = f.querySelector('[type=submit]'); btn?.classList.add('is-busy');
    const fd = new FormData(f); fd.append('sections', SEC); fd.append('sections_url', location.pathname);
    const r = await fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
    btn?.classList.remove('is-busy');
    const data = await r.json();
    if (!r.ok) { toast(esc(data.description || T.strings.error)); return; }
    paint(data.sections);
    if (window.gsap) gsap.fromTo('[data-cart-count]', { scale: 1.7 }, { scale: 1, duration: .7, ease: 'elastic.out(1,.4)' });
    const inDrawer = f.closest('#drawer');
    if (cfg().openOnAdd !== false && drawer && !inDrawer) openCart(true);
    else toast(`${data.image ? `<img src="${data.image}${data.image.includes('?') ? '&' : '?'}width=80" alt="">` : ''}${esc(data.product_title)} · ${esc(T.strings.added)}`);
  });

  // pagina carrello: quantità → submit automatico
  $$('form[data-cart-page] [data-q-input]').forEach(i => i.addEventListener('change', () => i.form.submit()));

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-step]'); if (!b) return;
    const inp = b.parentElement.querySelector('input'); if (!inp) return;
    inp.value = Math.max(+inp.min || 0, (+inp.value || 0) + +b.dataset.step);
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* =========================================================
     PRODUCT: variant picker + sticky add-to-cart
     ========================================================= */
  function initProduct(root) {
    const data = $('[data-product-json]', root); if (!data) return;
    const product = JSON.parse(data.textContent);
    const form = $('form[data-add]', root); if (!form) return;
    const idInput = $('[name=id]', form);
    const priceEl = $('[data-price]', root), btn = $('[data-atc]', root), stickyPrice = $('[data-sticky-price]');
    const fieldsets = $$('fieldset[data-opt]', root);
    const update = () => {
      const opts = fieldsets.map(fs => ($('input:checked', fs) || {}).value);
      const v = product.variants.find(v => v.options.every((o, i) => o === opts[i]));
      fieldsets.forEach((fs, i) => $$('input', fs).forEach(inp => {
        const ok = product.variants.some(x => x.available && x.options[i] === inp.value && x.options.every((o, j) => j === i || o === opts[j]));
        inp.closest('.chip').style.opacity = ok ? '' : '.4';
      }));
      if (!v) { btn.disabled = true; $('span', btn).textContent = T.strings.unavailable; return; }
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ` <s>${money(v.compare_at_price)}</s>` : '');
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      btn.disabled = !v.available;
      $('span', btn).textContent = v.available ? T.strings.add : T.strings.soldOut;
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
    };
    fieldsets.forEach(fs => $$('input', fs).forEach(i => i.addEventListener('change', update)));
    const sticky = $('.sticky-atc');
    if (sticky && btn && 'IntersectionObserver' in window) new IntersectionObserver(([en]) => sticky.classList.toggle('on', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(btn);
    $('button', sticky || document.createElement('i'))?.addEventListener('click', () => form.requestSubmit());
  }

  /* ---------- description → tabs (titoli in grassetto che finiscono con ":") ---------- */
  function splitDescription(root) {
    const box = $('[data-desc]', root); if (!box || box.dataset.done) return;
    const src = $('.rte', box); if (!src) return;
    const isHead = el => {
      if (!/^(P|H[2-6]|STRONG|B)$/.test(el.tagName)) return null;
      const txt = el.textContent.trim();
      if (!txt || txt.length > 48) return null;
      const strong = /^(STRONG|B|H[2-6])$/.test(el.tagName) ? el : el.querySelector('strong,b');
      if (!strong || strong.textContent.trim() !== txt) return null;
      return txt.replace(/[:：]\s*$/, '');
    };
    const groups = [{ title: box.dataset.first, nodes: [] }];
    [...src.childNodes].forEach(n => {
      const h = n.nodeType === 1 ? isHead(n) : null;
      if (h) groups.push({ title: h, nodes: [] });
      else if (n.nodeType === 1 || n.textContent.trim()) groups[groups.length - 1].nodes.push(n);
    });
    const real = groups.filter(g => g.nodes.length);
    if (real.length < 2) { box.dataset.done = 1; return; }
    box.innerHTML = '';
    real.forEach((g, i) => {
      const d = document.createElement('details'); if (i === 0) d.open = true;
      d.innerHTML = `<summary>${esc(g.title)}</summary><div class="rte"></div>`;
      g.nodes.forEach(n => $('.rte', d).appendChild(n));
      box.appendChild(d);
    });
    box.dataset.done = 1;
  }

  /* ---------- zoom immagini prodotto ---------- */
  function initZoom(root) {
    if (!matchMedia('(hover:hover)').matches) return;
    $$('[data-zoom]', root).forEach(m => {
      const img = $('img', m); if (!img) return;
      m.addEventListener('click', () => m.classList.toggle('zoom'));
      m.addEventListener('mousemove', e => { const r = m.getBoundingClientRect(); img.style.transformOrigin = `${(e.clientX - r.left) / r.width * 100}% ${(e.clientY - r.top) / r.height * 100}%`; });
      m.addEventListener('mouseleave', () => m.classList.remove('zoom'));
    });
  }

  /* ---------- altro dallo stesso brand (pagina vendor via Section Rendering API) ---------- */
  async function initBrand(root) {
    const el = $('[data-brand-url]', root); if (!el) return;
    const r = await fetch(el.dataset.brandUrl); if (!r.ok) return;
    const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
    const cards = $$('[data-brand-cards] .card', doc).filter(c => !$(`a[href*="${el.dataset.exclude}"]`, c)).slice(0, +el.dataset.limit || 4);
    if (!cards.length) return;
    const grid = $('.grid', el); cards.forEach(c => grid.appendChild(document.importNode(c, true)));
    el.hidden = false;
    if (anim) { $$('.card', grid).forEach(c => gsap.set(c, { opacity: 1, y: 0 })); ScrollTrigger.refresh(); }
  }

  /* ---------- product recommendations ---------- */
  async function initReco(root) {
    const el = $('[data-reco-url]', root); if (!el) return;
    const r = await fetch(el.dataset.recoUrl); if (!r.ok) return;
    const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
    const inner = doc.querySelector('[data-reco-url]');
    if (inner && inner.querySelector('.card')) {
      el.innerHTML = inner.innerHTML; el.hidden = false;
      if (anim) { $$('.card', el).forEach(c => gsap.set(c, { opacity: 1, y: 0 })); ScrollTrigger.refresh(); }
    }
  }

  /* =========================================================
     COLLECTION FILTERS
     ========================================================= */
  const fp = $('#filters');
  function closeFilters() { if (fp?.classList.contains('on')) { fp.classList.remove('on'); veil?.classList.remove('on'); lock(false); } }
  document.addEventListener('click', e => {
    if (e.target.closest('[data-open-filters]') && fp) { fp.classList.add('on'); veil?.classList.add('on'); lock(true); }
    if (e.target.closest('[data-close-filters]')) closeFilters();
  });
  veil?.addEventListener('click', () => { openCart(false); closeFilters(); });
  addEventListener('pageshow', e => { if (e.persisted) refresh(); });
  addEventListener('keydown', e => { if (e.key === 'Escape') { openCart(false); closeFilters(); if (mnav?.classList.contains('on')) { mnav.classList.remove('on'); lock(false); } } });
  $$('[data-sort]').forEach(s => s.addEventListener('change', () => {
    const u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u;
  }));
  $$('form[data-quick-filter] input').forEach(i => i.addEventListener('change', () => i.form.submit()));

  /* =========================================================
     ANIMATIONS
     ========================================================= */
  function intro(done) {
    const loader = $('#loader');
    let seen = true;
    try { seen = !!sessionStorage.getItem('bc_intro'); sessionStorage.setItem('bc_intro', 1); } catch (e) {}
    if (!loader || seen || design) { loader?.remove(); document.body.classList.remove('loading'); return done(); }
    lenis?.stop();
    const prog = { v: 0 };
    gsap.timeline()
      .to('#loader .mono span', { y: 0, duration: 1.1, stagger: .08, ease: 'expo.out' })
      .to(prog, { v: 100, duration: 1.5, ease: 'power2.inOut', onUpdate: () => { $('#loader .count span').textContent = Math.round(prog.v); gsap.set('#loader .bar i', { scaleX: prog.v / 100 }); } }, '<')
      .to('#loader .l-in', { y: -40, opacity: 0, duration: .6, ease: 'power3.in' })
      .to('#loader', { yPercent: -100, duration: 1.1, ease: 'expo.inOut' }, '-=.15')
      .add(() => { document.body.classList.remove('loading'); lenis?.start(); done(); }, '-=.8')
      .add(() => loader.remove());
  }

  const inits = {
    hero(s) {
      const isIntro = s.classList.contains('intro');
      const tl = gsap.timeline({ delay: .1 });
      if (isIntro) tl.fromTo(s, { clipPath: 'inset(12% 18% 12% 18% round 6px)' }, { clipPath: 'inset(0% 0% 0% 0% round 6px)', duration: 1.6, ease: 'expo.inOut' }).to($('.bg', s), { scale: 1.06, duration: 2.2, ease: 'expo.out' }, '<');
      tl.to($$('h1 .line > span', s), { y: 0, duration: 1.3, stagger: .1, ease: 'expo.out' }, isIntro ? '-=1.1' : 0)
        .to($('.side', s), { opacity: 1, duration: 1 }, '-=.8');
      gsap.to($('.bg', s), { yPercent: 12, ease: 'none', scrollTrigger: { trigger: s, start: 'top top', end: 'bottom top', scrub: true } });
      gsap.to($('.copy', s), { y: -80, opacity: 0, ease: 'none', scrollTrigger: { trigger: s, start: 'center top', end: 'bottom top', scrub: true } });
    },
    marquee(s) {
      const tr = $('.track', s); if (!tr) return;
      let x = 0, dir = 1;
      const tick = () => { const w = tr.scrollWidth / 3; const v = lenis ? Math.min(Math.abs(lenis.velocity), 60) : 0; x -= (0.6 + v * .25) * dir; if (x <= -w) x += w; if (x > 0) x -= w; gsap.set(tr, { x }); };
      gsap.ticker.add(tick); s._kill = () => gsap.ticker.remove(tick);
      lenis?.on('scroll', e => { if (e.direction) dir = e.direction; });
    },
    manifesto(s) {
      const m = $('.big', s); if (!m) return;
      if (!m.dataset.split) {
        m.dataset.split = 1;
        const walk = n => [...n.childNodes].forEach(c => {
          if (c.nodeType === 3) {
            const f = document.createDocumentFragment();
            c.textContent.split(/(\s+)/).forEach(w => { if (!w) return; if (/^\s+$/.test(w)) f.append(w); else { const sp = document.createElement('span'); sp.className = 'w'; sp.textContent = w; f.append(sp); } });
            c.replaceWith(f);
          } else if (c.nodeType === 1) walk(c);
        });
        walk(m);
      }
      gsap.to($$('.w', s), { opacity: 1, stagger: .08, ease: 'none', scrollTrigger: { trigger: m, start: 'top 78%', end: 'bottom 45%', scrub: true } });
      $$('[data-count]', s).forEach(b => { const o = { v: 0 }; gsap.to(o, { v: +b.dataset.count, duration: 2, ease: 'power3.out', scrollTrigger: { trigger: b, start: 'top 90%' }, onUpdate: () => b.textContent = Math.round(o.v) + (b.dataset.suffix || '') }); });
    },
    cats(s) { gsap.from($$('.cat', s), { y: 120, opacity: 0, duration: 1.4, stagger: .1, ease: 'expo.out', scrollTrigger: { trigger: s, start: 'top 85%' } }); },
    rail(s) {
      const rail = $('.rail', s); if (!rail || !isDesk()) return;
      const dist = () => Math.max(0, rail.scrollWidth - innerWidth);
      if (dist() < 40) return;
      gsap.to(rail, { x: () => -dist(), ease: 'none', scrollTrigger: { trigger: s, start: 'top top', end: () => '+=' + dist(), pin: true, scrub: 1, invalidateOnRefresh: true, onUpdate: st => gsap.set($('.rail-progress i', s), { scaleX: st.progress }) } });
      $$('.card .im img:not(.alt)', rail).forEach((im, i) => gsap.fromTo(im, { rotate: i % 2 ? 4 : -4 }, { rotate: i % 2 ? -4 : 4, ease: 'none', scrollTrigger: { trigger: s, start: 'top top', end: () => '+=' + dist(), scrub: true } }));
    },
    ritual(s) {
      const steps = $$('.step', s), shots = $$('.shot', s), dots = $$('.dots b', s);
      if (!steps.length) return;
      const first = { trigger: s, start: 'top 60%' };
      gsap.set(steps, { autoAlpha: 0, y: 50 });
      gsap.set(steps[0], { autoAlpha: 1, y: 0 });
      gsap.set($$('.line > span', s), { y: 0 });
      gsap.set($$('.n, p', s), { opacity: 1 });
      // entrata del primo step: anima solo i figli, il contenitore lo gestisce la timeline
      gsap.from($$('.n, h3, p', steps[0]), { opacity: 0, y: 40, duration: 1.1, stagger: .08, ease: 'expo.out', scrollTrigger: first });
      const rt = gsap.timeline({ scrollTrigger: { trigger: $('.pin', s), start: 'top top', end: () => '+=' + innerHeight * (steps.length - .6), pin: true, scrub: 1 } });
      if (dots[0]) rt.fromTo(dots[0], { scaleX: 0 }, { scaleX: 1, duration: 1, ease: 'none' }, 0);
      for (let i = 1; i < steps.length; i++) {
        rt.fromTo(steps[i - 1], { autoAlpha: 1, y: 0 }, { autoAlpha: 0, y: -50, duration: .45, ease: 'power2.in', immediateRender: false }, i)
          .fromTo(steps[i], { autoAlpha: 0, y: 50 }, { autoAlpha: 1, y: 0, duration: .55, ease: 'power2.out', immediateRender: false }, i + .4);
        if (shots[i]) rt.to(shots[i], { clipPath: 'inset(0% 0 0 0)', duration: .8, ease: 'power2.inOut' }, i).fromTo($('img', shots[i]), { scale: 1.25 }, { scale: 1, duration: .9 }, i);
        if (dots[i]) rt.fromTo(dots[i], { scaleX: 0 }, { scaleX: 1, duration: 1, ease: 'none' }, i);
      }
      rt.to({}, { duration: .3 });
    },
    common(s) {
      $$('.reveal', s).forEach(el => !el.closest('.grid') && gsap.to(el, { opacity: 1, y: 0, duration: 1.2, ease: 'expo.out', scrollTrigger: { trigger: el, start: 'top 92%' } }));
      $$('.px', s).forEach(el => { const k = +el.dataset.s || 8; gsap.fromTo(el, { yPercent: -k }, { yPercent: k, ease: 'none', scrollTrigger: { trigger: el.parentElement, start: 'top bottom', end: 'bottom top', scrub: true } }); });
      $$('.sec-head h2, .page-title', s).forEach(h => gsap.from(h, { y: 60, opacity: 0, duration: 1.3, ease: 'expo.out', scrollTrigger: { trigger: h, start: 'top 90%' } }));
      $$('.grid .card, .grid .tile', s).forEach((c, i) => gsap.fromTo(c, { opacity: 0, y: 40 }, { opacity: 1, y: 0, duration: 1, delay: (i % 4) * .06, ease: 'expo.out', scrollTrigger: { trigger: c, start: 'top 95%' } }));
      $$('.giant', s).forEach(g => gsap.from(g, { yPercent: 60, opacity: 0, duration: 1.6, ease: 'expo.out', scrollTrigger: { trigger: g, start: 'top 98%' } }));
    },
  };

  function initSection(sec) {
    initProduct(sec); initReco(sec); splitDescription(sec); initZoom(sec); initBrand(sec);
    if (!anim) return;
    sec._ctx = gsap.context(() => {
      $$('[data-anim]', sec).forEach(el => el.dataset.anim.split(' ').forEach(k => inits[k]?.(el)));
      inits.common(sec);
    }, sec);
  }

  const secs = $$('.shopify-section');
  const heroSec = secs.find(s => $('[data-anim~="hero"]', s));
  secs.forEach(s => { if (s !== heroSec) initSection(s); });
  if (anim) intro(() => { heroSec && initSection(heroSec); ScrollTrigger.refresh(); });
  else { $('#loader')?.remove(); document.body.classList.remove('loading'); heroSec && initSection(heroSec); }
  addEventListener('load', () => anim && ScrollTrigger.refresh());

  /* ---------- theme editor ---------- */
  if (design) {
    document.addEventListener('shopify:section:load', e => { initSection(e.target); anim && ScrollTrigger.refresh(); });
    document.addEventListener('shopify:section:unload', e => { e.target._ctx?.revert(); $$('[data-anim]', e.target).forEach(el => el._kill?.()); });
  }
})();
